import type { Vector2 } from '@/vector';

const CLIENT_VIEW_DISTANCE = 50;

export function getDistance(a: Vector2, b: Vector2): number {
  const dx = Math.abs(a.x - b.x);
  const dy = Math.abs(a.y - b.y);
  return Math.floor(dx + dy);
}

export function inRange(observer: Vector2, other: Vector2): boolean {
  return getDistance(observer, other) <= CLIENT_VIEW_DISTANCE;
}
